export const place = { id: "diario", path: "/diario" } as const;
